import { EcommerceStrategyIcon, RestaurantsAndHospitalityStrategyIcon, TravelTourismStrategyIcon } from '@/svgs'
import React from 'react'

function FiFromStrategy() {
   return (
      <section id="development-guide-section" className="section_secondary_bg">
         <div className="container">
            <h2 className="section_heading_title mb-3">
               From Vision to Experience: Our Restaurant & Hospitality Software
               Development Process
            </h2>

            <p className="section_desc">
               With 12+ years of expertise in restaurant and hospitality software development, we build seamless, scalable, and high-performance solutions. Our disciplined process elevates guest experiences, streamlines operations, and propels business expansion.
            </p>

            <RestaurantsAndHospitalityStrategyIcon />
         </div>
      </section>
   )
}

export default FiFromStrategy
